import React from 'react';

const D3Rating = ({ 
  value = 3.5, 
  maxStars = 5, 
  scale = 1.5, 
  maxWidth = 115, 
  baseStarSize = 18,
  starColor = '#E97917' 
}) => {
  const percentage = Math.max(0, Math.min(100, (value / maxStars) * 100));
  const starSize = baseStarSize * scale;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontFamily: 'sans-serif' }}>
      <span style={{ fontWeight: 600, color: '#111', fontSize: '15px' }}>Current Rating:</span>
      
      <div 
        style={{ 
          position: 'relative', 
          display: 'inline-block', 
          lineHeight: 1, 
          width: `${maxWidth}px`,
          height: `${starSize}px`
        }}
      >
        {/* Background Layer: Empty Stars */}
        <div 
          style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            color: starColor, 
            width: '100%',
            position: 'absolute',
            top: 0,
            left: 0
          }}
        >
          {[...Array(maxStars)].map((_, i) => (
            <span key={`empty-${i}`} style={{ fontSize: `${starSize}px`, lineHeight: 1, display: 'inline-block' }}>☆</span>
          ))}
        </div>

        {/* Foreground Layer: Filled Stars with Non-Distorting Percentage Clip */}
        <div 
          style={{ 
            position: 'absolute', 
            top: 0, 
            left: 0, 
            width: `${percentage}%`, 
            height: '100%',
            overflow: 'hidden',
            pointerEvents: 'none'
          }}
        >
          <div 
            style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              color: starColor, 
              width: `${maxWidth}px`,
              position: 'absolute',
              top: 0,
              left: 0
            }}
          >
            {[...Array(maxStars)].map((_, i) => (
              <span key={`filled-${i}`} style={{ fontSize: `${starSize}px`, lineHeight: '1', display: 'inline-block' }}>★</span>
            ))}
          </div>
        </div>
      </div>

      {value>0 && <span style={{ fontWeight: 700, color: '#111', fontSize: '14px', marginLeft: '4px' }}>
        {(value*1).toFixed(2)}
      </span>}
    </div>
  );
};

export default D3Rating;